<template>
  <div>
    <!-- <Breadcrumb :links="breadcrumbs" /> -->
    <ValidationObserver ref="observer">
      <div class="vx-row">
        <div class="vx-col w-full">
          <ul class="heading-ul mb-3">
            <li class="flex items-center ml-4">
              <router-link to="/manageCodesList" class="mr-2 vx-row">
                <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
              </router-link>
              <h3>{{ $t("system.label.EditManageCodes") }}</h3>
            </li>
          </ul>
        </div>
        <div class="vx-col w-full">
          <vx-card title no-shadow card-border>
            <div class="vx-row mb-5">
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-2/5 xl:w-2/1">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.CodeValue')"
                  :key="resetKey"
                >
                  <vs-input
                    v-model="name"
                    :label="$t('system.label.CodeValue')"
                    class="w-full mb-5 font-semibold starlabel"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-2/5 xl:w-2/1">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('system.label.Position')"
                  :key="resetKey"
                >
                  <vs-input
                    v-model="position"
                    :label="$t('system.label.Position')"
                    class="w-full mb-5 font-semibold starlabel"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/6">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  class="mb-2 w-full createPlusBtn"
                  @click="createEditCode"
                  >{{ $t("system.label.Add") }}</vs-button
                >
              </div>
            </div>
            <div
              class="vx-row"
              v-for="(codeValuesData, index) in this.codeValuesDataId"
              :key="index"
            >
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-2/5 xl:w-2/1">
                <vs-input
                  v-model="codeValuesData.name"
                  class="w-full mb-5 font-semibold"
                  disabled
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-2/5 xl:w-2/1">
                <vs-input
                  v-model="codeValuesData.position"
                  class="w-full mb-5 font-semibold"
                  disabled
                />
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/2 xl:w-1/6">
                <feather-icon
                  icon="TrashIcon"
                  :title="$t('system.label.Delete')"
                  svgClasses="w-5 h-5 text-danger stroke-current cursor"
                  class="ml-2 mt-6 icon_row"
                  @click="deleteValueCodes(codeValuesData.id)"
                />
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  data() {
    return {
      breadcrumbs: [
        { name: this.$t("reports.label.configurations"), to: "/config" },
        {
          name: this.$t("system.label.EditManageCodes"),
          to: "/",
        },
      ],
      resetKey: 0,
      codeValuesDataId: {},
      dataIdCodes: {},
      name: "",
      position: "",
    };
  },
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  computed: {},
  methods: {
    async dataByIdcodevalues() {
      try {
        const response = await this.$store.dispatch(
          "manageCodes/setdataByIdcodevalues",
          this.id
        );
        this.codeValuesDataId = response.data;
      } catch (error) {
        error;
      }
    },
    async dataByIdCodes() {
      try {
        const response = await this.$store.dispatch(
          "manageCodes/setdataByIdCodes",
          this.id
        );
        this.dataIdCodes = response.data;
      } catch (error) {
        error;
      }
    },
    async createEditCode() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) return;

      let payload = {
        name: this.name,
        position: this.position,
      };
      await this.$store.dispatch("manageCodes/createCodevaluesAction", {
        id: this.id,
        data: payload,
      });
      this.$swal({
        title: "Success",
        icon: "success",
        text: "Manage Codes Edited Successfully!",
        type: "success",
      });
      this.resetForm();
      this.resetKey++;
      this.dataByIdcodevalues();
    },
    async deleteValueCodes(index) {
      try {
        await this.$store.dispatch("manageCodes/deleteCodeValuesAction", {
          id: this.id,
          data: index,
        });
        this.dataByIdcodevalues();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    resetForm() {
      this.name = "";
      this.position = "";
    },
  },

  created() {
    this.id = this.$route.params.id;
    this.dataByIdcodevalues();
    this.dataByIdCodes();
  },
};
</script>
<style scoped>
.createPlusBtn {
  top: 14px;
  height: 39px;
}
</style>
